export const searchStyleByValue = (value) => {
    switch (value) {
        case 'created':
            return 'bg-gray-100 text-gray-500'
        case 'pending':
            return 'bg-red-100 text-red-500'
        case 'completed':
            return 'bg-blue-100 text-blue-500'
        case 'approved':
            return 'bg-green-100 text-green-500'
        case 'Pendiente':
            return 'bg-yellow-500 text-white'
        case 'En proceso':
            return 'bg-blue-500 text-white'
        default:
            return ''
    }
}

export const searchDicByValue = (value) => {
    switch (value) {
        case 'created':
            return 'Creado'
        case 'pending':
            return 'Pendiente'
        case 'completed':
            return 'Completado'
        case 'approved':
            return 'Aprobado'
        default:
            return value
    }
}